<script lang="ts">
  import Icon from './Icon.svelte';
  import Logo from './Logo.svelte';

  let {
    onHome,
    onProfile,
    custom,
    profileName,
  }: { onHome: () => void; onProfile: () => void; custom: boolean; profileName: string } = $props();
</script>

<header class="header">
  <div class="inner">
    <button class="brand" onclick={onHome} aria-label="gostword — на главную">
      <Logo size={30} />
      <span class="name">gostword</span>
    </button>
    <button class="profile" onclick={onProfile} title="Настроить требования под методичку">
      <Icon name="sliders" size={17} />
      <span class="profile-name">{profileName}</span>
      {#if custom}<span class="custom">+ методичка</span>{/if}
    </button>
  </div>
</header>

<style>
  .header {
    position: sticky;
    top: 0;
    z-index: 30;
    background: color-mix(in srgb, var(--bg) 86%, transparent);
    backdrop-filter: saturate(1.4) blur(12px);
    border-bottom: 1px solid var(--border);
  }

  .inner {
    max-width: 1240px;
    height: 60px;
    margin: 0 auto;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .brand {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px;
    border: 0;
    background: none;
    cursor: pointer;
  }

  .name {
    font-size: 17px;
    font-weight: 680;
    letter-spacing: -0.02em;
  }

  .profile {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 36px;
    padding: 0 14px;
    border: 1px solid var(--border);
    border-radius: 999px;
    background: var(--surface);
    color: var(--text-2);
    font-size: 14px;
    cursor: pointer;
    transition: border-color 0.15s;
  }

  .profile:hover {
    border-color: var(--border-strong);
    color: var(--text);
  }

  .custom {
    color: var(--accent);
    font-weight: 600;
  }

  @media (max-width: 560px) {
    .inner {
      padding: 0 16px;
    }

    .profile-name {
      display: none;
    }
  }
</style>
